import _ from 'lodash';
import moment from 'moment';
import update from 'react-addons-update';

import {
    RECEIVED_AUTHED_USER,
    SET_LOGGED_IN,
    SET_ERROR,
    CLEAR_ERROR,
    LOADING_UPDATED,
    LOADING_FINISHED,
    SET_SNACKBAR,
    CLEAR_SNACKBAR,
    RECEIVED_PERSON,
} from '../constants';

let localStorageLoggedIn = false;
try {
    localStorageLoggedIn = window.localStorage.getItem(`loggedIn`) === `true`;
} catch (ex) {}

const initialState = {
    loggedIn: localStorageLoggedIn,
    user: {},
    person: {},
    // Format =
    // error: {
    //    messageLines: [`Paragraph 1`, `Paragraph 2`],
    //    dismissText:``,
    //    reloadText: ``,
    // }
    error: null,
    // Format =
    // loading: {
    //     graphic: `delorean`,
    //     message: `mah loading screen`,
    // },
    loading: null,
    // Format =
    // snackbar: {
    //     message: ``,
    //     callback: () => {} // NOTE: support for this is not yet implemented
    // }
    snackbar: null,
};

export default function environment(state = initialState, action) {
    switch (action.type) {
        case RECEIVED_PERSON:
            return update(state, { person: { $set: action.person } });
        case RECEIVED_AUTHED_USER:
            return update(state, { user: { $set: action.user } });
        case SET_LOGGED_IN:
            return update(state, { loggedIn: { $set: action.loggedIn } });
        case SET_ERROR:
            return update(state, {
                error: {
                    $set: {
                        messageLines: action.messageLines,
                        dismissText: _.get(action.options, `dismissText`),
                        reloadText: _.get(action.options, `reloadText`),
                    }
                }
            });
        case CLEAR_ERROR:
            return update(state, { error: { $set: null } });
        case LOADING_UPDATED:
            return update(state, { loading: {
                $set: {
                    message: action.message,
                    graphic: action.graphic,
                }
            }});
        case LOADING_FINISHED:
            return update(state, { loading: { $set: null } });
        case SET_SNACKBAR:
            return update(state, {
                snackbar: {
                    $set: {
                        message: action.message,
                        callback: action.callback,
                    }
                }
            });
        case CLEAR_SNACKBAR:
            return update(state, { snackbar: { $set: null } });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./scripts/reducers/environment.js